import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { Store } from '@ngrx/store';
import { State } from 'src/app/reducers';
import { Observable } from 'rxjs';
import { authenticateUser } from 'src/app/store/auth/auth.actions';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  // Attachment to the store
  formName = 'Sign In';
  authenticating$: Observable<boolean>;
  authenticatingError$: Observable<string>;

  signUpForm = new FormGroup({});
  model: any = {};
  options: FormlyFormOptions = {};

  fields: FormlyFieldConfig[] = [
    {
      key: 'username',
      type: 'input',
      templateOptions: {
        required: true,
        type: 'text',
        label: 'Email',
        appearance: 'outline',
      },
    },
    {
      key: 'password',
      type: 'input',
      templateOptions: {
        required: true,
        type: 'password',
        label: 'Password',
        appearance: 'outline',
      },
    },
  ];
  constructor(private router: Router, private store: Store<State>) {
    this.authenticating$ = store.select(state => state.auth.authenticating);
    this.authenticatingError$ = store.select(state => state.auth.authenticatingError);
  }

  ngOnInit(): void {}

  submit() {
    if (this.signUpForm.valid) {
      this.store.dispatch(authenticateUser({username: this.signUpForm.value.username, password: this.signUpForm.value.password}));
    }
  }
}
